import React from 'react';
import { RouterProvider, useNavigate } from 'react-router-dom';
import config, { ENABLE_MOCKS } from 'config';
import { MockAuth0Provider } from 'utils/auth/MockAuth0Provider';
import { Auth0Provider } from '@auth0/auth0-react';
import 'styles/fonts.css';
import 'styles/app.css';
import router from 'routes';

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const onRedirectCallback = appState => {
    const returnTo = appState?.returnTo ?? window.location.pathname;

    try {
      const parsed = new URL(returnTo);
      window.location.replace(parsed.toString());
    } catch {
      navigate(returnTo, { replace: true });
    }
  };

  if (ENABLE_MOCKS) {
    return <MockAuth0Provider>{children}</MockAuth0Provider>;
  } else {
    // For the pro-portal sign-up flow, "New User? Create an Account" on Auth0's
    // login page should return to /sign-up (preserving query params such as
    // userType and phoneNumber). All other flows — including the Shopify
    // distributor flow which needs to return to the three-tile /get-started page
    // even when the user is currently on /sign-up — use /get-started.
    const isDistributorFlow =
      new URLSearchParams(window.location.search).get('userType') ===
      'distributor';
    const signUpPath =
      window.location.pathname.startsWith('/sign-up') && !isDistributorFlow
        ? '/sign-up'
        : '/get-started';

    return (
      <Auth0Provider
        audience={config.audience}
        domain={config.domain}
        clientId={config.clientId}
        onRedirectCallback={onRedirectCallback}
        redirectUri={window.location.origin}
        scope={config.scope}
        useRefreshTokens={true}
        signUpUrl={`${window.location.origin}${signUpPath}${window.location.search}`}>
        {children}
      </Auth0Provider>
    );
  }
};

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
